import React from 'react';
import { CheckIcon } from '../icons';
import { cssInJS } from '../utils/styles';
import { BasemapOption as BasemapOptionType } from './basemaps';

interface BasemapOptionProps {
  map: BasemapOptionType;
  isChecked: boolean;
  onClick: () => void;
  testId: string;
  previewUrl: string | null;
}

const styles = cssInJS({
  basemapOption: {
    flex: '0 1 auto',
    position: 'relative',
    width: 136,
    padding: 8,
    cursor: 'pointer',
    ':hover': {
      backgroundColor: '#f1f1f1',
    },
  },

  basemapOptionImage: {
    width: 120,
    height: 120,
    background: '#f1f1f1',
    borderRadius: 2,
  },

  basemapOptionLabel: {
    width: 120,
    fontSize: 13,
    textAlign: 'center',
    paddingTop: 8,
  },

  checkPlaceholder: {
    width: 20,
    height: 20,
    background: '#fff',
    position: 'absolute',
    right: 12,
    top: 12,
    borderRadius: 10,
  },

  check: {
    position: 'absolute',
    width: 20,
    height: 20,
    right: 12,
    top: 12,
    paddingLeft: 4,
  },

}) as any;

const BasemapOption: React.FC<BasemapOptionProps> = ({
  map,
  isChecked,
  onClick,
  testId,
  previewUrl,
}) => {
  const containerStyle = styles.basemapOption;
  const imageStyle = styles.basemapOptionImage;
  const labelStyle = styles.basemapOptionLabel;
  const checkStyle = styles.check;
  const checkPlaceholderStyle = styles.checkPlaceholder;
  return (
    <div
      className={containerStyle}
      onClick={onClick}
      data-testid={testId}
      key={`basemap-option-${map.name}`}
    >
      <img
        className={imageStyle}
        src={previewUrl || undefined}
        alt={map.name}
      />
      <div className={labelStyle}>{map.name}</div>
      <div className={checkPlaceholderStyle} />
      {isChecked
        && (
          <div className={checkStyle}>
            <CheckIcon
              style={{ fill: '#7db400' }}
              width="12"
            />
          </div>
        )}
    </div>
  );
};

export default BasemapOption;
